import React from 'react';
import debounce from 'lodash/debounce';
import { Link } from 'react-router-dom';
import { Carousel, Input } from 'antd';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { LabeledValue, SelectValue } from 'antd/lib/select';
import { ThunkDispatch } from 'redux-thunk';
import { FormattedMessage } from 'react-intl';
import { get, isEmpty } from 'lodash';

import { SearchOutlined } from '@ant-design/icons';
import { RootState, UrlUtils } from '@share/utils';
import { FilterLocations } from '@components';
import { BlueButton, CustomSelect } from '@share/components';
import {
  getAllInclusiveSortOptions,
  GETAWAY_BACKGROUND_TRANSPARENT,
  GetGetawaysLocations,
  getGetawaySortOptions,
  renderGetawayListHeaderInfo,
} from '@utils';
import {
  getGetaways,
  getGetawaysLocations,
  getawaysActions,
  IGetawaysState,
  SubCategory,
} from '@store/slices';
import { IBenefitsState, IMenuState } from '@share/store/slices';
import {
  GetGetawaysArgs,
  IGetawaysLocations,
  defaultLocationValue,
  GetawaysLocationEnum,
  defaultLocationCountriesValue,
} from '@share/common-types';
import { DEFAULT_PAGE_SIZE, MEDIA_POINT, Routes, SortTypes } from '@share/constants';
import { APP_SELECTOR, DEFAULT_ALLINCLUSIVE_PAGE_SIZE, NULL_VALUE, UNDEFINED_VALUE } from '@constants';
import { GETAWAY_LOCATION, GETAWAY_SORT_ORDER } from '@share/constants';
import { ILoginState } from '@share/store/slices';

import { GetawayListCard } from '../getaway-list-card';
import { GetawayListSkeleton } from '../getaway-list-skeleton';
import { GetawayListCardSkeleton } from '../getaway-list-card-skeleton';

import './style.scss';

const ZERO = 0;
const ONE = 1;
const THREE = 3;
const FOUR = 4;
const DEBOUNCE_TIME = 300;
const DEBOUNCE_TIME_SEARCH = 500;
const SLICER_DEBOUNCE_TIME_SEARCH = 6000;
const SCROLL_PIXELS = 620;

const SPEED = 1000;
const SLIDES_TO_SHOW = 3;
const SLIDES_TO_SHOW_MOBILE = 1;
const SLIDES_TO_SHOW_MEDIA = 2;
const SLIDES_TO_SCROLL = 1;

const propsCarouselDesktop = {
  dots: true,
  infinite: true,
  arrows: true,
  speed: SPEED,
  slidesToShow: SLIDES_TO_SHOW,
  slidesToScroll: SLIDES_TO_SCROLL,
  autoplay: true,
};

const propsCarouselMobile = {
  ...propsCarouselDesktop,
  slidesToShow: SLIDES_TO_SHOW_MOBILE,
};

const propsCarouselMediaMobile = {
  ...propsCarouselDesktop,
  slidesToShow: SLIDES_TO_SHOW_MEDIA,
};

interface IMapStateToProps {
  getawaysStore: IGetawaysState;
  benefitsStore: IBenefitsState;
  menuStore: IMenuState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  getGetaways: GetGetawaysArgs;
  getGetawaysLocations: (getaway: string, subCategory: SubCategory) => void;
  setSortType: (sort: SortTypes, subCategory: SubCategory) => void;
  setFiltrationType: (type: IGetawaysLocations, subCategory: SubCategory) => void;
  setFiltrationTypeCountry: (country: IGetawaysLocations, subCategory: SubCategory) => void;
  setPageNumber: (page: number, subCategory: SubCategory) => void;
  setPromoId: (promoId: string, subCategory: SubCategory) => void;
  setGetawaysListPage: (listPage: boolean, subCategory: SubCategory) => void;
  setDefaultValues: (subCategory: SubCategory) => void;
  resetFilters: (subCategory: SubCategory) => void;
  setActiveGetawaySubCategory: (subCategory: SubCategory) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {
  isInternal: boolean;

  isFromProperty?: boolean;
  getaway?: string;
  condoSubcategory?: string | null | undefined;

  isHome?: boolean;
  isSlider?: boolean;
  isAllInclusive?: boolean;

  title?: string;
  subtitle?: string;

  sliderRotation?: boolean;
  maxValues?: number;
  hideFilter?: boolean;
  disablePagination?: boolean;
  disableOnScroll?: boolean;
  displayOriginal?: boolean;
  displayTopHeader?: boolean;

  isCarrousel?: boolean;
}

interface IState {
  isCondo: boolean;
  activeGetaway: string;
  activeCondoSubcategory: string;
  realTimeGetaway: SubCategory;
}

class GetawayListComponent extends React.Component<IProps, IState> {
  root: HTMLDivElement = document.querySelector(APP_SELECTOR) as HTMLDivElement;
  wrapperRef: React.RefObject<HTMLDivElement> = React.createRef();
  prevWrapperRef: any = null;
  interval: any = null;

  state: IState = {
    isCondo: false,
    activeGetaway: NULL_VALUE,
    activeCondoSubcategory: NULL_VALUE,
    realTimeGetaway: NULL_VALUE,
  };

  onScroll = debounce(() => {
    this.handleDeals(false);
  }, DEBOUNCE_TIME);

  handleDeals = (skipElement: boolean) => {
    const { isCondo, activeGetaway, activeCondoSubcategory, realTimeGetaway } = this.state;
    const { isSlider, isAllInclusive, setPageNumber, getawaysStore } = this.props;

    const { getaways, loadingGetaways, getawaysTotalCount, loadingMoreGetaways } = getawaysStore[
      realTimeGetaway
    ];

    const scrollLeft = get(this.wrapperRef.current, 'scrollLeft', 0);
    const offsetWidth = get(this.wrapperRef.current, 'offsetWidth', 0);
    const scrollWidth = get(this.wrapperRef.current, 'scrollWidth', 0);

    const windowInnerHeight = window.innerHeight; 
    const windowScrollY = window.scrollY; 
    const windowHeigth = windowInnerHeight + windowScrollY + SCROLL_PIXELS;
    const defaultPageSize = isAllInclusive ? DEFAULT_ALLINCLUSIVE_PAGE_SIZE : DEFAULT_PAGE_SIZE;

    if (
      !loadingGetaways &&
      !loadingMoreGetaways &&
      getaways.length &&
      getaways.length !== getawaysTotalCount &&
      getaways.length % defaultPageSize === ZERO &&
      this.root &&
      (skipElement ||
        (!isSlider && windowHeigth >= this.root.offsetHeight) ||
        (isSlider && scrollLeft + offsetWidth >= scrollWidth))
    ) {
      setPageNumber(UNDEFINED_VALUE, realTimeGetaway);
      this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE, true);
    }
  };

  componentDidMount() {
    const values = UrlUtils.getValues();
    const {
      isSlider,
      isHome,
      disableOnScroll,
      isFromProperty,
      getaway,
      condoSubcategory,
      sliderRotation,
      loginStore,
      menuStore,
      setSortType,
      setFiltrationType,
      setFiltrationTypeCountry,
      setGetawaysListPage,
      getGetawaysLocations,
      setActiveGetawaySubCategory,
    } = this.props;
    const { user, account } = loginStore;
    const { items } = menuStore;
    const queryGetawayLocation = values[GETAWAY_LOCATION];
    const queryGetawaySortOrder = values[GETAWAY_SORT_ORDER];
    const activeGetaway = isFromProperty ? getaway : location.pathname.split('/')[THREE];
    const activeCondoSubcategory = isFromProperty
      ? condoSubcategory
      : location.pathname.split('/')[FOUR];

    const realTimeGetaway = (activeCondoSubcategory ?? activeGetaway) as SubCategory;

    const isCondo =
      activeGetaway === GetawaysLocationEnum.Condo.toLowerCase() ||
      activeGetaway === GetawaysLocationEnum.Condos.toLowerCase();
    const isRSITemplate = account?.isRSITemplate;

    setGetawaysListPage(true, realTimeGetaway);
    this.setState({ isCondo, activeGetaway: activeGetaway as string, activeCondoSubcategory: activeCondoSubcategory as string, realTimeGetaway });

    setActiveGetawaySubCategory(activeCondoSubcategory as SubCategory);

    setFiltrationTypeCountry(UNDEFINED_VALUE, realTimeGetaway);

    if (queryGetawayLocation) {
      setFiltrationType(queryGetawayLocation as IGetawaysLocations, realTimeGetaway);
    }

    if (queryGetawaySortOrder) {
      setSortType(queryGetawaySortOrder as SortTypes, realTimeGetaway);
    }

    if (isSlider) {
      this.prevWrapperRef = this.wrapperRef.current;
    } else {
      if (!isHome && !disableOnScroll) {
        window.addEventListener('scroll', this.onScroll);
      }
    }

    if (user) {
      if (!isRSITemplate) {
        getGetawaysLocations(activeGetaway as string, realTimeGetaway);
        this.handleGetaways(activeGetaway as string, isCondo ? activeCondoSubcategory : NULL_VALUE);
      } else if (items) {
        getGetawaysLocations(activeGetaway as string, realTimeGetaway);
        this.handleGetaways(activeGetaway as string, isCondo ? activeCondoSubcategory : NULL_VALUE);
      }
    }

    if (isSlider && sliderRotation) {
      this.interval = setInterval(() => {
        const scrollLeft = get(this.wrapperRef.current, 'scrollLeft', 0);
        const offsetWidth = get(this.wrapperRef.current, 'offsetWidth', 0);
        const scrollWidth = get(this.wrapperRef.current, 'scrollWidth', 0);
    
        if (scrollLeft + offsetWidth >= scrollWidth) {
          this.wrapperRef.current?.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });
      
        } else {
          this.handleScrollRight();
        }
      }, SLICER_DEBOUNCE_TIME_SEARCH);
    }
  
  }

  handleGetaways = (
    getaway: string,
    subCategory?: string,
    isLoadMore?: boolean,
    isSearch?: boolean,
  ) => {
    const { getawaysStore, disablePagination, maxValues } = this.props;

    const { realTimeGetaway } = this.state;

    const getaways = realTimeGetaway ? getawaysStore[realTimeGetaway].getaways : [];

    if ((!disablePagination || !isLoadMore) && (!maxValues || getaways?.length < maxValues)) {
      this.props.getGetaways(getaway, subCategory as SubCategory, isLoadMore, isSearch);
    }
  };

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    const { activeGetaway, isCondo, activeCondoSubcategory } = this.state;
    const { disableOnScroll, loginStore, menuStore, getGetawaysLocations, setActiveGetawaySubCategory } = this.props;
    const { user, account } = loginStore;
    const { items } = menuStore;

    const isRSITemplate = account?.isRSITemplate;

    if (!prevProps?.loginStore?.user && user && !isRSITemplate) {
      getGetawaysLocations(activeGetaway, isCondo ? (activeCondoSubcategory as SubCategory) : NULL_VALUE);
      this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE);
      setActiveGetawaySubCategory(activeCondoSubcategory as SubCategory);
    }

    if (!prevProps?.menuStore?.items && items && isRSITemplate) {
      getGetawaysLocations(activeGetaway, isCondo ? (activeCondoSubcategory as SubCategory) : NULL_VALUE);
      this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE);
      setActiveGetawaySubCategory(activeCondoSubcategory as SubCategory);
    }

    if (this.prevWrapperRef !== this.wrapperRef.current && !disableOnScroll) {
      this.wrapperRef.current?.addEventListener('scroll', this.onScroll);
    }

    this.prevWrapperRef = this.wrapperRef.current;
  }

  componentWillUnmount() {
    const { realTimeGetaway } = this.state;
    const { disableOnScroll, setGetawaysListPage, setDefaultValues } = this.props;
    setGetawaysListPage(false, realTimeGetaway);
    setDefaultValues(realTimeGetaway);

    if (!disableOnScroll) {
      window.removeEventListener('scroll', this.onScroll);
      this.wrapperRef?.current?.removeEventListener('scroll', this.onScroll);
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onSearchHandler = debounce(({ target }) => {
    const { realTimeGetaway } = this.state;
    const { value } = target;
    const { setPromoId, setPageNumber } = this.props;
    const { isCondo, activeGetaway, activeCondoSubcategory } = this.state;

    setPromoId(value, realTimeGetaway);

    setPageNumber(ONE, realTimeGetaway);
    this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE, false, true);
  }, DEBOUNCE_TIME_SEARCH);

  onFilterChange = (value: string): void => {
    const { realTimeGetaway } = this.state;
    const { getawaysStore, setFiltrationType, setPageNumber } = this.props;
    const { isCondo, activeGetaway, activeCondoSubcategory } = this.state;
    const activeFilterOption = getawaysStore[realTimeGetaway].getawaysLocations.find(
      (item) => item.city === value,
    );

    const selectedFiltrationType =
      activeFilterOption?.city === defaultLocationValue ? undefined : activeFilterOption;

    setFiltrationType(selectedFiltrationType as IGetawaysLocations, realTimeGetaway);
    UrlUtils.setUrl(GETAWAY_LOCATION, selectedFiltrationType);

    setPageNumber(ONE, realTimeGetaway);
    this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE);
  };

  onCountryFilterChange = (value: string): void => {
    const { realTimeGetaway } = this.state;
    const {
      getawaysStore,
      setFiltrationTypeCountry,
      setFiltrationType,
      setPageNumber,
    } = this.props;
    const { isCondo, activeGetaway, activeCondoSubcategory } = this.state;

    const activeFilterOption = getawaysStore[realTimeGetaway].getawaysLocationsCountries.find(
      (item) => item.isoCountry === value,
    );

    const selectedFiltrationType =
      activeFilterOption?.city === defaultLocationCountriesValue ? undefined : activeFilterOption;

    const getawaysLocations = GetGetawaysLocations(
      selectedFiltrationType as IGetawaysLocations,
      getawaysStore[realTimeGetaway].getawaysLocationsOriginal,
    );
    const filtrationType = getawaysLocations?.length === 1 ? getawaysLocations[0] : undefined;

    setFiltrationTypeCountry(selectedFiltrationType as IGetawaysLocations, realTimeGetaway);
    setFiltrationType(filtrationType as IGetawaysLocations, realTimeGetaway);

    setPageNumber(ONE, realTimeGetaway);
    this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE);
  };

  onSortChange = (value: SelectValue): void => {
    const { realTimeGetaway } = this.state;
    const { setSortType, setPageNumber } = this.props;
    const { isCondo, activeGetaway, activeCondoSubcategory } = this.state;
    setSortType(value as SortTypes, realTimeGetaway);
    UrlUtils.setUrl(GETAWAY_SORT_ORDER, value as SortTypes);
    setPageNumber(ONE, realTimeGetaway);
    this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE);
  };

  getSortOptions = (): LabeledValue[] => {
    if (this.props.isAllInclusive) {
      return getAllInclusiveSortOptions();
    }

    return getGetawaySortOptions();
  };

  resetFilters = (): void => {
    const { realTimeGetaway } = this.state;
    const { resetFilters } = this.props;
    const { isCondo, activeGetaway, activeCondoSubcategory } = this.state;

    resetFilters(realTimeGetaway);
    this.handleGetaways(activeGetaway, isCondo ? activeCondoSubcategory : NULL_VALUE);
  };

  handleScrollLeft = () => {
    const windowWidth = window.innerWidth;
    const padding = windowWidth > 580 ? 550 : windowWidth - 10;
    this.wrapperRef.current?.scrollTo({
      top: 0,
      left: this.wrapperRef.current.scrollLeft - padding,
      behavior: 'smooth',
    });
  };

  handleScrollRight = () => {
    const windowWidth = window.innerWidth;
    const padding = windowWidth > 580 ? 550 : windowWidth - 10;
    this.wrapperRef.current?.scrollTo({
      top: 0,
      left: this.wrapperRef.current.scrollLeft + padding,
      behavior: 'smooth',
    });
  };

  render(): React.ReactNode {
    const {
      benefitsStore,
      getawaysStore,
      intl,
      menuStore,
      isSlider,
      isHome,
      isAllInclusive,
      hideFilter,
      maxValues,
      title,
      subtitle,
      displayOriginal,
      displayTopHeader
    } = this.props;
    const { isCondo, activeGetaway, activeCondoSubcategory, realTimeGetaway } = this.state;

    if (!realTimeGetaway) {
      return null;
    }

    const {
      promoId,
      getaways,
      originalGetaways,
      sortType,
      filterType,
      filterTypeCountry,
      loadingGetaways,
      getawaysLocations,
      getawaysLocationsCountries,
      getawaysTotalCount,
      loadingMoreGetaways,
      loadingGetawaysLocations,
    } = getawaysStore[realTimeGetaway];
    const phone = menuStore?.items?.phone;
    const headerInfo = renderGetawayListHeaderInfo(
      isCondo ? activeCondoSubcategory : activeGetaway,
    );

    const { loginStore } = this.props;
    const { account } = loginStore;

    const toLowercaseSpecialTypeName = activeGetaway?.toLowerCase();
    const isTypeNameStaycation = toLowercaseSpecialTypeName === GetawaysLocationEnum.Staycation;

    const fromHome = benefitsStore.benefits?.fromHome;

    const style: any = {};
    if (isSlider) {
      style.flexWrap = 'unset';
      style.flexDirection = 'row';
      style.overflowX = 'scroll';
    }

    const getawaysInt = displayOriginal ? originalGetaways ? originalGetaways : [] : getaways;
    const getawaysFinal = (!maxValues || getawaysInt?.length <= maxValues) ? getawaysInt : getawaysInt.slice(0, maxValues);
    
    const mainStyle: any = {};
    if (!isHome) {
      mainStyle.background = `url(${headerInfo?.headerImg}) center / cover no-repeat ${GETAWAY_BACKGROUND_TRANSPARENT}`;
    } else {
      if (!getawaysFinal?.length && !filterType?.city) {
        return null;
      }
    }

    const isMobile = document.body.offsetWidth <= 850;
    const isMediaMobile = document.body.offsetWidth <= MEDIA_POINT;
    const propsCarousel = isMobile ? 
                              propsCarouselMobile : 
                              isMediaMobile ? 
                                  propsCarouselMediaMobile : 
                                  propsCarouselDesktop;
  
    const isNewCondos = activeGetaway == GetawaysLocationEnum.Condos || activeGetaway == GetawaysLocationEnum.NewCondos;

    return (
      <div className={`getaway__list__container${isHome ? ' getaway__list-home-page' : ''}`}>
        {displayTopHeader && 
          <span className="getaway__list__container_header"><em></em></span>}

        <div className={`getaway__list-header ${isHome ? 'home-page' : ''} ${displayTopHeader ? 'display-top-header' : ''}`} style={mainStyle}>
          <div className={`getaway__container ${isHome ? 'home-page' : ''}`}>
            {!isEmpty(title) ? (
              <h1 className={`getaway__list-header_title secondary-font ${isHome ? 'home-page' : ''}`}>
                {title}
              </h1>) : (
              <h1 className={`getaway__list-header_title secondary-font ${isHome ? 'home-page' : ''}`}>
                {headerInfo && <FormattedMessage id={headerInfo.headerTitle} />}
              </h1>)}
            <p className={`getaway__list-header_subtitle ${isHome ? 'home-page' : ''}`}>
              {subtitle || (headerInfo && <FormattedMessage id={headerInfo?.headerSubtitle} />)}
            </p>
          </div>
        </div>
        <div className="getaway__list first" style={{ paddingTop: loadingGetaways ? '20px' : '0px' }}>
          {loadingGetaways ? (
            <GetawayListSkeleton isSlider={isSlider} />
          ) : (
            <div className={`getaway__container ${isHome ? 'home-page' : ''}`}>
              {!isHome ? (
                !isCondo ? (
                  <Link
                    className="getaway__list__back-link"
                    to={`/${account?.name}${fromHome ? Routes.Search : Routes.Getaway}`}
                  >
                    <FormattedMessage
                      id={fromHome ? 'confirmation.go.back_home' : 'getaways.back'}
                    />
                  </Link>
                ) : (
                  <Link
                    className="getaway__list__back-link"
                    to={`/${account?.name}${isNewCondos ? Routes.GetawayCondos : Routes.GetawayCondo}`}
                  >
                    <FormattedMessage id={'getaways.back.condo'} />
                  </Link>
                )
              ) : null}

              <div className="getaway__list-top">
                <div className={`getaway__list-filters ${isHome ? 'home-page' : ''}`}>
                  {!hideFilter && (
                    <div className="getaway__list-filters-filter">
                      <FilterLocations
                        value={filterType?.city as string}
                        options={getawaysLocations}
                        onChange={this.onFilterChange}
                        disabled={loadingGetawaysLocations || !getawaysLocations.length}
                        disableSort={isAllInclusive}
                      />

                      {getawaysLocationsCountries.length > 1 && menuStore?.items?.isMLM ? (
                        <FilterLocations
                          value={filterTypeCountry?.country as string}
                          options={getawaysLocationsCountries}
                          onChange={this.onCountryFilterChange}
                          disabled={loadingGetawaysLocations || !getawaysLocationsCountries.length}
                          getOptionValue={(obj: any) => {
                            return obj?.isoCountry;
                          }}
                          isCountryBased
                        />
                      ) : null}
                    </div>)}

                  {!isTypeNameStaycation && !isHome && !isNewCondos ? (
                    <div className="getaway__list-filters-search">
                      <Input
                        defaultValue={promoId}
                        onChange={this.onSearchHandler}
                        placeholder={intl.formatMessage({ id: 'search.promo.id' })}
                        prefix={<SearchOutlined />}
                      />
                    </div>
                  ) : null}
                </div>

                {(!isHome || (!isSlider && isAllInclusive)) ? (
                  <div className="getaway__list-sort">
                    <p className="getaway__list-sort_text">
                      <FormattedMessage id="sort.by" />
                      {':'}
                    </p>
                    <div className="getaway__list-sort_wrapper">
                      <CustomSelect
                        value={sortType}
                        onChange={this.onSortChange}
                        options={this.getSortOptions()}
                      />
                    </div>
                  </div>
                ) : null}
              </div>

              {!isHome ? (
                <div className="getaway__list-count_wrapper">
                  <p className="getaway__list-count">
                    {!!getawaysTotalCount && '+'}
                    {getawaysTotalCount} <FormattedMessage id="getaways" />
                  </p>
                  {(promoId || filterType) && (
                    <div onClick={this.resetFilters} className="getaway__list-reset">
                      <FormattedMessage id="reset.search" />
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          )}
        </div>

        {!loadingGetaways ? (
          <div className="getaway__list last">
            <div className={`getaway__container ${isHome ? 'home-page' : ''} ${isSlider ? 'is-slider' : ''}`}>
              {(isSlider && getawaysFinal.length && getawaysFinal.length >= propsCarousel.slidesToShow) ? (
                <Carousel {...propsCarousel} lazyLoad="ondemand">
                  {getawaysFinal.map((getaway, index) => (
                    <GetawayListCard
                      key={`${getaway.title}-${!!getaway.promoId ? getaway.promoId : index}`}
                      data={getaway}
                      condoSubcategory={activeCondoSubcategory}
                      activeGetaway={activeGetaway}
                      isSlider
                    />
                  ))}
                </Carousel>) : (

                  <div
                    className={`getaway__list-wrapper`}
                    style={style}
                    ref={this.wrapperRef}
                  >
                    {getawaysFinal.length
                      ? getawaysFinal.map((getaway, index) => (
                          <GetawayListCard
                            key={`${getaway.title}-${!!getaway.promoId ? getaway.promoId : index}`}
                            data={getaway}
                            condoSubcategory={activeCondoSubcategory}
                            activeGetaway={activeGetaway}
                          />
                        ))
                      : !loadingMoreGetaways && (
                          <p>
                            <FormattedMessage id="getaway.message" values={{ phone }} />
                          </p>
                        )}
                    {loadingMoreGetaways && isSlider && (
                      <GetawayListCardSkeleton blocks={1} isSlider={isSlider} noMarginTop />
                    )}
                  </div>)}

              
              {loadingMoreGetaways && !isSlider && <GetawayListCardSkeleton />}
              {!isSlider && isHome && getawaysFinal.length !== getawaysTotalCount ? (
                <div className="getaway__list-load-more-container">
                  <BlueButton onClick={() => this.handleDeals(true)}>
                    <FormattedMessage id="deals.load.more" />
                  </BlueButton>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    getawaysStore: state.getawaysStore,
    benefitsStore: state.benefitsStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  getGetaways: (getaway, subCategory, isLoadMore, isSearch) => {
    dispatch(getGetaways(getaway, subCategory, isLoadMore, isSearch));
  },
  getGetawaysLocations: (getaway, subCategory) => {
    dispatch(getGetawaysLocations(getaway, subCategory as SubCategory));
  },
  setSortType: (value, subCategory) => {
    dispatch(getawaysActions.setSortType({ sort: value, subCategory }));
  },
  setFiltrationType: (value, subCategory) => {
    dispatch(getawaysActions.setFiltrationType({ type: value, subCategory }));
  },
  setFiltrationTypeCountry: (value, subCategory) => {
    dispatch(getawaysActions.setFiltrationTypeCountry({ country: value, subCategory }));
  },
  setPageNumber: (pageNumber, subCategory) => {
    dispatch(getawaysActions.setPageNumber({ page: pageNumber, subCategory }));
  },
  setPromoId: (promoId, subCategory) => {
    dispatch(getawaysActions.setPromoId({ promo: promoId, subCategory }));
  },
  setDefaultValues: (subCategory) => {
    dispatch(getawaysActions.setDefaultValues({ subCategory }));
  },
  setGetawaysListPage: (isGetawayListPage, subCategory) => {
    dispatch(getawaysActions.setGetawaysListPage({ listPage: isGetawayListPage, subCategory }));
  },
  resetFilters: (subCategory) => {
    dispatch(getawaysActions.resetFilters({ subCategory }));
  },
  setActiveGetawaySubCategory: (subCategory: SubCategory) => {
    dispatch(getawaysActions.setActiveGetawaySubCategory({ subCategory }));
  },
});

export const GetawayList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GetawayListComponent));
